import { EntryTemplate } from '../../components/Templates/Auth/EntryTemplate';
import { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSessionStore } from '../../stores/SessionStore';
const EntryScreen: React.FC = () => {
  const navigate = useNavigate();
  const isLoggedIn = useSessionStore((state) => state.isLoggedIn);

  const onClickNew = useCallback(() => {
    navigate('/register');
  }, [navigate]);

  const onClickExisting = useCallback(() => {
    navigate('/login');
  }, [navigate]);

  useEffect(() => {
    if (isLoggedIn()) {
      navigate('/home');
    }
  }, [isLoggedIn, navigate]);

  return (
    <EntryTemplate onClickNew={onClickNew} onClickExisting={onClickExisting} />
  );
};
export default EntryScreen;
